import React, { useState } from "react";
import { Box, Flex, Text, Collapse, Icon } from "@chakra-ui/react";
import { ChevronDownIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { NavLink, useLocation } from "react-router-dom";

const DropdownMenu = ({ route }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const textColor = "rgba(255, 255, 255, 0.72)";

  const isRouteActive = (path) => location.pathname.includes(path);
  const isDropdownTitleActive = route.subRoutes?.some((subRoute) => isRouteActive(subRoute.path));

  return (
    <Box mb="4px">
      <Flex
        align="center"
        py="10px"
        px="12px"
        borderRadius="12px"
        bg={isDropdownTitleActive ? "rgba(139, 225, 90, 0.16)" : "transparent"}
        border="1px solid"
        borderColor={isDropdownTitleActive ? "rgba(139, 225, 90, 0.28)" : "transparent"}
        _hover={{ bg: "rgba(255, 255, 255, 0.06)", cursor: "pointer" }}
        onClick={() => setIsOpen(!isOpen)}
      >
        {route.icon && (
          <Box me="12px" color={isDropdownTitleActive ? "#8BE15A" : textColor} lineHeight="0">
            {React.cloneElement(route.icon, { color: "inherit" })}
          </Box>
        )}
        <Text
          color={isDropdownTitleActive ? "white" : textColor}
          fontWeight={isDropdownTitleActive ? "500" : "400"}
          fontSize="14px"
        >
          {route.name}
        </Text>
        <Icon as={isOpen ? ChevronDownIcon : ChevronRightIcon} color={textColor} ml="auto" />
      </Flex>
      <Collapse in={isOpen}>
        {route.subRoutes?.map((subRoute, index) => {
          const active = isRouteActive(subRoute.path);
          return (
            <Box pl="12px" key={index} mt="2px">
              <NavLink to={subRoute.layout + subRoute.path}>
                <Flex
                  align="center"
                  py="9px"
                  px="12px"
                  borderRadius="10px"
                  bg={active ? "rgba(139, 225, 90, 0.14)" : "transparent"}
                  _hover={{ bg: "rgba(255, 255, 255, 0.06)" }}
                >
                  {subRoute.icon && (
                    <Box me="10px" color={active ? "#8BE15A" : textColor} lineHeight="0">
                      {React.cloneElement(subRoute.icon, { color: "inherit" })}
                    </Box>
                  )}
                  <Text
                    color={active ? "white" : textColor}
                    fontWeight={active ? "500" : "400"}
                    fontSize="13.5px"
                  >
                    {subRoute.name}
                  </Text>
                </Flex>
              </NavLink>
            </Box>
          );
        })}
      </Collapse>
    </Box>
  );
};

export default DropdownMenu;
